import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@/components/ui/button';

const LoginButton = () => {
	const { loginWithRedirect, isLoading } = useAuth0();

	return (
		<Button className="min-w-20" variant="secondary" isLoading={isLoading} onClick={() => loginWithRedirect()}>
			Log In
		</Button>
	);
};

export default LoginButton;
